export const AutoDisplayLightboxSymbol = Symbol('AutoDisplayLightbox')

export const name = 'autoDisplayLightbox' as const
export { VSM_EDITOR_CONFIGS_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
